module.exports = __webpack_public_path__ + "img/43.8d2b578a.jpg";